import React, { useState } from 'react'

import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import {
    AccountingSystem,
    accountingSystems,
    defaultAccountingSystem,
} from '../types/AccountingSystem'

interface Props {
    show: boolean
    onClose: () => void
    onConfirm: (system: AccountingSystem) => void
}

/**
 * Asks which accounting program the export is for. POHODA gets its native XML, the rest get
 * ISDOC, which all of them import.
 */
export const AccountingSystemDialog = ({show, onClose, onConfirm}: Props) => {
    const {t} = useTranslation()
    const [system, setSystem] = useState<AccountingSystem>(defaultAccountingSystem)

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title className={'fs-21'}>{t('export_choose_system')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className={'mb-3'}>{t('export_choose_system_hint')}</p>
                {accountingSystems.map((option) => (
                    <div className={'form-check mb-2'} key={option.value}>
                        <input className={'form-check-input'}
                               type={'radio'}
                               name={'accounting-system'}
                               id={'accounting-system-' + option.value}
                               checked={system === option.value}
                               onChange={() => setSystem(option.value)}/>
                        <label className={'form-check-label d-flex justify-content-between w-100'}
                               htmlFor={'accounting-system-' + option.value}>
                            <span>{option.label}</span>
                            <span className={'text-muted'}>{option.format}</span>
                        </label>
                    </div>
                ))}
            </Modal.Body>
            <Modal.Footer>
                <button type={'button'} className={'btn amani-secondary'} onClick={onClose}>
                    {t('cancel')}
                </button>
                <button type={'button'} className={'btn amani-primary'} onClick={() => {
                    onConfirm(system)
                    onClose()
                }}>
                    {t('export')}
                </button>
            </Modal.Footer>
        </Modal>
    )
}
